'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dRule$002dId$0024 from "./presto.types$-Rule-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_Rules$$anon$1(outer) {
  this.buH = null;
  this.buF = null;
  this.buG = false;
  this.buD = null;
  this.buE = false;
  this.buI = false;
  this.buJ = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.buH = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_Rules$$anon$1 as $c_Lpresto_Rules$$anon$1 };
$p = $c_Lpresto_Rules$$anon$1.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Rules$$anon$1;
/** @constructor */
function $h_Lpresto_Rules$$anon$1() {
}
export { $h_Lpresto_Rules$$anon$1 as $h_Lpresto_Rules$$anon$1 };
$h_Lpresto_Rules$$anon$1.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.buH;
});
$p.t = (function() {
  if ((!this.buG)) {
    this.buF = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.buG = true;
  }
  return this.buF;
});
$p.ad = (function() {
  if ((!this.buE)) {
    this.buD = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRule$002dId$0024.$m_Lpresto_types$RuleId$().a2q(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.buE = true;
  }
  return this.buD;
});
$p.v = (function() {
  if ((!this.buJ)) {
    this.buI = false;
    this.buJ = true;
  }
  return this.buI;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_Rules$$anon$1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Rules$$anon$1, "presto.Rules$$anon$1", ({
  QE: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_Rules$$anon$1 as $d_Lpresto_Rules$$anon$1 };
//# sourceMappingURL=presto.-Rules$$anon$1.js.map
